import React from 'react';
import PropTypes from 'prop-types';
import AcademyConfigProp from './propTypes/academyConfig';
import TermsProp from '../../commonComponents/propTypes/termsProp';
import BrandingProp from '../../commonComponents/propTypes/brandingProp';
import translate from '../../commonComponents/translate';
import NewsletterForm from './footer/NewsletterForm';
import SupportSection from './footer/SupportSection';

function LandingFooter({ t, academyConfig, terms, branding }) {
  return (
    <div className="landing-footer">
      <div className="landing-logo-newsletter-section">
        {academyConfig && academyConfig.footerLogo && (
          <img
            src={academyConfig.footerLogo}
            alt="logo"
            className="landing-footer-logo"
          />
        )}
        <NewsletterForm />
      </div>
      <SupportSection academyConfig={academyConfig} terms={terms} />
      <div className="landing-copyright-section">
        <p className="landing-copyright-text">
          {`©2020 ${branding.appName}. ${t('landing_allRights')}`}
        </p>
      </div>
    </div>
  );
}

LandingFooter.propTypes = {
  t: PropTypes.func.isRequired,
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
  terms: PropTypes.shape(TermsProp.propType),
  branding: PropTypes.shape(BrandingProp.propType).isRequired,
};

LandingFooter.defaultProps = {
  terms: null,
};

export default translate(LandingFooter);
